/**
 * Component to handle Side Menu integration
 *
 * The module is acting as integration between SB and Side Menu.
 *
 * @module app/components/SideMenu
 */
import DeviceDetector from './DeviceDetector';
import DrawersAdapter from '../components/DrawersAdapter';
import jQuery from 'jquery';
import MessageBusTopics from '../../common/MessageBusTopics';
import PageCommon from '../pages/PageCommon';
import _ from 'lodash';

/**
 * createNavigationClickedData
 * @param open
 * @returns {{item: string, interaction: string}}
 */
function createNavigationClickedData(open) {
    return {
        item: 'Left Hand Nav',
        interaction: open ? 'Opened' : 'Closed',
    };
}

/**
 * publishNativeSideMenuOpen - TDRD-3249 native compatibility to sidebarNavigation.open
 * @param topic
 * @param slugValue
 * @returns {void}
 */
function publishNativeSideMenuOpen(topic, slugValue) {
    if (slugValue && slugValue.length) {
        window.WH.messageBus.publish(
            'sidemenu.open', { slug: slugValue }
        );
    }
}

/**
 * startSideMenu
 */
function startSideMenu() {
    var fixTheBody = function() {
        productMenu
            .removeClass('is-not-active')
            .addClass('is-active');
        var pageYOffset = -window.pageYOffset + 'px';
        mainContainer.css('top', pageYOffset);
        mainContainer.css('position', 'fixed');
        rootElement.css('overflow', 'hidden');
    };

    var releaseTheBody = function() {
        if (productMenu.hasClass('product-menu-sports')) {
            productMenu.removeClass('is-active');
        }
        var rect = document.querySelector('.main-container').getBoundingClientRect();
        mainContainer.css('top', 0);
        mainContainer.css('position', 'relative');
        rootElement.css('overflow', 'auto');
        window.scrollTo(0, -rect.top);
    };

    var burgerToggleElement = jQuery('body #header #burger-toggle');
    var burgerPreIntegratedHeader = jQuery('#header .sb-header-hamburger');
    if (burgerPreIntegratedHeader.length || (burgerToggleElement.length && burgerToggleElement.data('is-active'))) {

        var sideMenuElement = jQuery('#side-menu');
        var headerElement = jQuery('#header');
        var rootElement = jQuery('body');
        var mainContainer = jQuery('.main-container');
        var burgerButton = burgerPreIntegratedHeader.length ? burgerPreIntegratedHeader : burgerToggleElement;
        var productMenu = jQuery('#p-menu');

        var STATEMAP = {
            open: {
                classHandler: 'addClass',
                fixFn: fixTheBody,
                clickData: true,
            },
            close: {
                classHandler: 'removeClass',
                fixFn: releaseTheBody,
                clickData: false,
            },
        };

        var setSidebarNavigation = function setSidebarNavigation(toState) {
            var actions = STATEMAP[toState];
            return actions && function() {
                sideMenuElement[actions.classHandler]('is-active');
                if (!burgerPreIntegratedHeader.length) {
                    headerElement[actions.classHandler]('is-side-active');
                }
                rootElement[actions.classHandler]('is-side-active');
                actions.fixFn();
                burgerButton[actions.classHandler]('-expanded');
                window.WH.messageBus.publish(
                    MessageBusTopics.NAVIGATION_MOBILE_CLICKED, createNavigationClickedData(actions.clickData)
                );

                if (toState === 'close' && rootElement.attr('data-panel-open') === 'right') {
                    DrawersAdapter.closeBetSlip();
                }
            };
        };

        burgerButton.on('click', function() {
            if (!rootElement.hasClass('is-side-active')) {
                window.WH.messageBus.publish(MessageBusTopics.SIDEBAR_NAVIGATION_OPEN);
            } else {
                window.WH.messageBus.publish(MessageBusTopics.SIDEBAR_NAVIGATION_CLOSE);
            }
        });

        window.WH.messageBus.subscribe(MessageBusTopics.SIDEBAR_NAVIGATION_OPEN, setSidebarNavigation('open'));
        window.WH.messageBus.subscribe(MessageBusTopics.SIDEBAR_NAVIGATION_CLOSE, setSidebarNavigation('close'));

        window.WH.messageBus.subscribe(MessageBusTopics.SIDEBAR_NAVIGATION_GO_TO_URL,
            function(a, data) {
                if (data.url.startsWith('#')) {
                    window.location.hash = data.url;
                    const livePersonEnabled = window.whStatic.config.livePerson.enabled || false;
                    if (livePersonEnabled && data.url.startsWith('#'+window.whStatic.config.livePerson.elementId)) {
                        window.WH.messageBus.publish(MessageBusTopics.OPEN_LIVE_CHAT);
                        window.location.hash = '';
                    }
                    return;
                }
                PageCommon.navigate(data.url);
            }
        );
    }
}

export default {
    init: function() {
        if (DeviceDetector.isNative() && !(DeviceDetector.isNativeSpain())) {
            window.WH.messageBus.subscribe(MessageBusTopics.SIDEBAR_NAVIGATION_OPEN, publishNativeSideMenuOpen);
            return;
        }

        startSideMenu();
    },
};
